module.exports = __webpack_public_path__ + "media/images/client-mathnasium-2-cd71592b5be9225eb3100e9a7c115349.png";